{
  "SET_NEW_PASSWORD": {
    "TITLE": "Neues Passwort festlegen",
    "PASSWORD": {
      "LABEL": "Passwort",
      "PLACEHOLDER": "Passwort",
      "ERROR": "Das Passwort ist zu kurz."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Passwort bestätigen",
      "PLACEHOLDER": "Bestätige das Passwort",
      "ERROR": "Passwörter stimmen nicht überein."
    },
    "API": {
      "SUCCESS_MESSAGE": "Das Passwort wurde erfolgreich geändert.",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "CAPTCHA": {
      "ERROR": "Verifizierung abgelaufen. Bitte Captcha erneut lösen."
    },
    "SUBMIT": "Einreichen"
  }
}
